import { render, staticRenderFns } from "./previewPdf.vue?vue&type=template&id=3f590e6a&scoped=true&"
import script from "./previewPdf.vue?vue&type=script&lang=js&"
export * from "./previewPdf.vue?vue&type=script&lang=js&"
import style0 from "./previewPdf.vue?vue&type=style&index=0&id=3f590e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f590e6a",
  null
  
)

export default component.exports